import { Element } from "react-scroll";
import SectionTitle2 from "../sectionTitle/SectionTitle2";
import { Link } from "react-router-dom";

export default function HomeAIResearchInnovation() {

  const upskilling = [
    {
      id: 1,
      image: "iot-5g-and-cybersecurity/iot-5g-and-cybersecurity.webp",
      title: "Data Sovereignty",
      description: "Research into secure, localized AI processing that maintains data ownership and privacy compliance.",
      link: "/research/iot-5g-and-cybersecurity"
    },
    {
      id: 2,
      image: "advanced-manufacturing/advanced-manufacturing.webp",
      title: "Digital Twins",
      description: "Creating virtual replicas of physical systems for advanced simulation, prediction and optimization.",
      link: "/research/advanced-manufacturing"
    },
    {
      id: 3,
      image: "clean-technology/clean-technology.webp",
      title: "Smart Infrastructure",
      description: "Developing AI-powered solutions for CleanTech and Industrial IoT applications in smart cities.",
      link: "/research/clean-technology"
    },
  ]

  return (
    <>
      <Element
        name="HomeAIResearchInnovation"
        className="datatalent-section-gap mea-key-features"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5 justify-content-center">
            <div className="col-12 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-center"
                title = "AI Research & Innovation"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <p className="text-center section-description">Explore cutting-edge developments in AI and their practical applications. Partner with us to turn your cutting-edge AI Research into real-world scalable Industry solutions.</p>
            </div>
            {upskilling.map((upskill) => <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5" key={upskill.id}>
              <div className="home-iau-card">
                <div className="home-iau-image">
                  <img src={`${process.env.PUBLIC_URL}/images/research/${upskill.image}`} alt={upskill.title} />
                </div>
                <div className="home-iau-content">
                  <h5 className="mb-2">{upskill.title}</h5>
                  <p className="mb-4">{upskill.description}</p>
                  <Link to={upskill.link} className="d-flex flex-row align-items-center justify-content-start gap-2 home-links">Learn more<i className="icon-arrow-right-line-right"></i></Link>
                </div>
              </div>
            </div>)}
          </div>
        </div>
      </Element>
    </>
  )
}